export default __webpack_public_path__ + "static/media/icon-calendar.30dc5d8e.svg";